import { atom } from "jotai";

import { ZSL } from "../types";

/* Use fine-grained selector, hasZslAtom, to check if you have a template.
   Use fine-grained selector, templateSlugAtom, to get the template slug

   When performing a coarse-grained read, the component becomes dependent on the entire piece of state and
   will re-render when any part of it changes. If the component only needs a few attributes, then we're performing
   needless rendering when the unused attributes change.

   See: https://docs.k8s.zapier.com/editor/Architecture/StateManagement/Jotai/Patterns.html#prefer-using-fine-grained-selectors
*/
// Create a base atom for the ZSL state
const baseZslAtom = atom<ZSL | undefined>(undefined);
baseZslAtom.debugLabel = "baseZslAtom";

export const zslAtom = atom<
  ZSL | undefined,
  [ZSL | undefined | ((prev: ZSL | undefined) => ZSL | undefined)],
  void
>(
  // Getter
  (get) => get(baseZslAtom),
  // Setter
  (
    get,
    set,
    update: ZSL | undefined | ((prev: ZSL | undefined) => ZSL | undefined),
  ) => {
    // Get current ZSL state
    const currentZsl = get(baseZslAtom);
    // Apply the update (handling both direct and functional updates)
    const newZsl = typeof update === "function" ? update(currentZsl) : update;

    // Update ZSL state
    set(baseZslAtom, newZsl);
  },
);
zslAtom.debugLabel = "zslAtom";
